// adapts the search response for the expected state values
export const buildState = (response: Record<any, any>): Record<any, any> => {
  const results = response?.data?.results && response?.data?.results || [];
  const requestId = response.data.meta.request_id;

  return {
    results,
    requestId,
  };
};

// adapts the suggestions response for the expected state values
export const buildSuggestionsState = (
  response: Record<any, any>,
): Record<any, any> => {
  const results = response?.data?.results.documents !== null ? response?.data?.results : [];
  const requestId = response?.data?.meta?.request_id;
  return {
    results,
    requestId,
  };
};
